import palette from './palette';
import images from './images';

const SUCCESS_AVATAR = {
  height: 280,
  src: images.common.successImg,
  alt: 'success',
  width: 180,
  maxHeight: 280,
  maxWidth: 180,
  objectPosition: `${24}px ${103}px`,
};

const SUCCESS_SQUARE_AVATAR = {
  height: 180,
  src: images.common.successImg,
  width: 180,
  maxHeight: 180,
  maxWidth: 180,
  objectPosition: `${20}px ${65}px`,
};

const QUIZ_REJECTED_SQUARE_AVATAR = {
  height: 145,
  src: images.common.rejectedImg,
  width: 145,
  maxHeight: 145,
  maxWidth: 145,
  objectPosition: `${30}px ${40}px`,
};

const views = {
  performance: {
    bar: {
      barLoss: palette.error.darker,
      barLossBackground: palette.primary.lightest,
      barProfit: palette.primary.light,
      barProfitBackground: palette.primary.lightest,
      font: palette.text.secondary,
    },
    line: {
      background: palette.primary.lightest,
      border: palette.primary.lighter,
      font: palette.text.secondary,
      pointBackground: palette.background.main,
      pointBorder: palette.primary.light,
      pointHoverBackground: palette.primary.light,
      pointHoverBorder: palette.primary.light,
    },
    portfolio: {
      pieChartColors: [
        palette.primary.main,
        palette.success.main,
        palette.error.main,
        palette.success.light,
        palette.primary.light,
        palette.error.light,
        palette.primary.dark,
        palette.success.dark,
        palette.error.dark,
        palette.success.lighter,
        palette.error.lighter,
        palette.primary.lighter,
        palette.primary.lightest,
        palette.error.lightest,
        palette.success.lightest,
      ],
    },
    tradingStatistics: {
      chart1: {
        backgroundColor: palette.chart.chart1,
      },
      chart2: {
        backgroundColor: palette.chart.chart2,
      },
      chart3: {
        backgroundColor: palette.chart.chart3,
      },
    },
  },
  promotions: {
    tradingEssentialSubscription: {
      benefit: {
        minHeight: '65px',
        borderRadius: '10px',
        backgroundColor: palette.primary.lightest,
      },
      badge: {
        border: `1px solid ${palette.primary.lightest}`,
        backgroundColor: palette.background.main,
      },
    },
    howItWorks: {
      'howItWorksItem::after': {
        content: `url("${images.tradingView.tradingViewArrowImg}")`,
      },
      blockImage: {
        borderRadius: '10px',
        backgroundColor: palette.primary.lightest,
      },
    },
  },
  similarUsers: {
    icon: {
      color: palette.warning.main,
    },
  },
  quiz: {
    quizModal: {
      avatar: {
        height: 160,
        src: images.common.leaderboardImg,
        width: 180,
        maxHeight: 160,
        maxWidth: 180,
        objectPosition: `${-8}px ${34}px`,
      },
    },
    proQuizBlockedModal: {
      avatar: {
        ...QUIZ_REJECTED_SQUARE_AVATAR,
      },
    },
    quizBlockedModal: {
      avatar: {
        ...QUIZ_REJECTED_SQUARE_AVATAR,
      },
    },
    secondFailedModal: {
      avatar: {
        height: 145,
        src: images.common.waitingImg,
        width: 145,
        maxHeight: 145,
        maxWidth: 145,
        objectPosition: `${30}px ${40}px`,
      },
    },
    successQuizModal: {
      avatar: {
        height: 190,
        src: images.common.successImg,
        width: 250,
        maxHeight: 190,
        maxWidth: 250,
        objectPosition: `${20}px ${65}px`,
      },
    },
    tryAgainModal: {
      avatar: {
        height: 215,
        src: images.common.waitingImg,
        width: 215,
        maxHeight: 215,
        maxWidth: 215,
        objectPosition: `${11}px ${78}px`,
      },
    },
    upgradeBlockedModal: {
      avatar: {
        ...QUIZ_REJECTED_SQUARE_AVATAR,
      },
    },
    continueAsRetailsModal: {
      avatar: {
        height: 215,
        src: images.common.waitingImg,
        width: 215,
        maxHeight: 215,
        maxWidth: 215,
        objectPosition: `${11}px ${78}px`,
      },
    },
    preQuizModal: {
      avatar: {
        height: 215,
        src: images.common.waitingImg,
        width: 215,
        maxHeight: 215,
        maxWidth: 215,
        objectPosition: `${11}px ${78}px`,
      },
    },
  },
  tmd: {
    checkModal: {
      avatar: {
        height: 200,
        src: images.common.waitingImg,
        width: 180,
        maxHeight: 200,
        maxWidth: 180,
        objectPosition: `${10}px ${75}px`,
      },
    },
    failModal: {
      avatar: {
        height: 130,
        src: images.common.rejectedImg,
        width: 130,
        maxHeight: 130,
        maxWidth: 130,
        objectPosition: `${25}px ${40}px`,
      },
    },
    successModal: {
      avatar: {
        ...SUCCESS_SQUARE_AVATAR,
      },
    },
  },
  aml: {
    success: {
      avatar: {
        ...SUCCESS_SQUARE_AVATAR,
      },
    },
  },
  withdraw: {
    failed: {
      avatar: {
        height: 300,
        src: images.common.rejectedImg,
        width: 180,
        maxHeight: 300,
        maxWidth: 180,
        objectPosition: `${40}px ${60}px`,
      },
    },
    success: {
      avatar: {
        height: 300,
        src: images.common.successImg,
        width: 199,
        maxHeight: 300,
        maxWidth: 199,
        objectPosition: `${28}px ${105}px`,
      },
    },
  },
  cySecVerification: {
    personalVerification: {
      personalDetails: {
        avatar: {
          height: 150,
          src: images.common.waitingImg,
          width: 130,
          maxHeight: 150,
          maxWidth: 130,
          objectPosition: `${6}px ${54}px`,
        },
      },
      addressDetails: {
        avatar: {
          height: 90,
          src: images.common.noAccountsImg,
          width: 100,
          maxHeight: 90,
          maxWidth: 100,
          objectPosition: `${7}px ${34}px`,
        },
      },
      jurisdictionDetails: {
        avatar: {
          height: 83,
          src: images.fusionPlus.aboutFusionPlusImg,
          width: 70,
          maxHeight: 83,
          maxWidth: 70,
          objectPosition: `${-4}px ${25}px`,
        },
      },
    },
    questionnaire: {
      high: {
        avatar: {
          ...SUCCESS_AVATAR,
        },
      },
      medium: {
        avatar: {
          ...SUCCESS_AVATAR,
        },
      },
      low: {
        avatar: {
          height: 280,
          src: images.common.rejectedImg,
          alt: 'rejected',
          width: 180,
          maxHeight: 280,
          maxWidth: 180,
          objectPosition: `${28}px ${67}px`,
        },
      },
      tradingExperience: {
        avatar: {
          height: 150,
          src: images.common.waitingImg,
          width: 130,
          maxHeight: 150,
          maxWidth: 130,
          objectPosition: `${6}px ${54}px`,
        },
      },
      investmentKnowledge: {
        avatar: {
          height: 110,
          src: images.common.leaderboardImg,
          width: 100,
          maxHeight: 110,
          maxWidth: 100,
          objectPosition: `${-8}px ${23}px`,
        },
      },
      knowledgeRiskTolerance: {
        avatar: {
          avatar: {
            height: 110,
            src: images.common.sponsorImg,
            width: 132,
            maxHeight: 110,
            maxWidth: 132,
            objectPosition: `${0}px ${31}px`,
          },
        },
      },
      financialSituation: {
        avatar: {
          height: 83,
          src: images.fusionPlus.aboutFusionPlusImg,
          width: 70,
          maxHeight: 83,
          maxWidth: 70,
          objectPosition: `${-4}px ${25}px`,
        },
      },
    },
    accountSettings: {
      avatar: {
        height: 150,
        src: images.common.waitingImg,
        width: 130,
        maxHeight: 150,
        maxWidth: 130,
        objectPosition: `${6}px ${54}px`,
      },
      feedback: {
        avatar: {
          height: 300,
          src: images.common.waitingImg,
          alt: 'waiting',
          width: 280,
          maxHeight: 300,
          maxWidth: 280,
          objectPosition: `${13}px ${114}px`,
        },
      },
      congratulations: {
        avatar: {
          ...SUCCESS_AVATAR,
        },
      },
    },
    uploadDocuments: {
      identity: {
        avatar: {
          height: 90,
          src: images.common.noAccountsImg,
          width: 100,
          maxHeight: 90,
          maxWidth: 100,
          objectPosition: `${7}px ${34}px`,
        },
      },
      additionalIdentity: {
        avatar: {
          height: 150,
          src: images.common.waitingImg,
          width: 130,
          maxHeight: 150,
          maxWidth: 130,
          objectPosition: `${6}px ${54}px`,
        },
      },
      feedback: {
        avatar: {
          ...SUCCESS_AVATAR,
        },
      },
      welcome: {
        avatar: {
          height: 300,
          src: images.common.waitingImg,
          alt: 'waiting',
          width: 280,
          maxHeight: 300,
          maxWidth: 280,
          objectPosition: `${13}px ${114}px`,
        },
      },
    },
  },
};

export default views;
